<template>
    <div class="header-container">
        <div class="header-wrapper">
            <div>
                <!-- 演示logo替换 -->
                <!-- <img :src="userInfo.companyLogo"  alt="" class="logo"> -->
                <img src="../assets/img/logo.png" alt="" class="logo" style="cursor: pointer;" @click="to">
            </div>
            <div class="conten"></div>
            <div class="user">
                <div class="app">

                    <el-popover placement="bottom" width="80" trigger="hover">
                        <img src="../assets/img/appxz.png" alt="" style="width:150px;height: 150px;">
                        <div slot="reference" style="cursor: pointer;"> <i class="el-icon-mobile-phone"> </i>APP下载</div>

                    </el-popover>
                </div>
                <el-popover placement="bottom" width="300" trigger="click">
                    <div>
                        <div style="border-bottom: 1px solid #000;padding-bottom: 20px;" class="user-list">
                            <div class="user-img">
                                <img v-if="userInfo.companyLogo" :src="userInfo.companyLogo" alt="">
                                <img v-else src="../assets/img/qyzx.png" alt="">
                            </div>
                            <div class="user-name">
                                <div>
                                    <span v-if="userInfo.currentLoginName">{{ userInfo.currentLoginName }}</span>
                                    <span v-else> {{ hidePhoneNumber(userInfo.mobile) }}</span>
                                </div>
                                <div>{{ userInfo.companyName }}
                                </div>

                            </div>
                        </div>
                        <div class="tc">
                            <shqy slot="reference">
                                <div> 切换企业 <i style="margin-top: 2px;" class="el-icon-d-caret"></i>
                                </div>
                            </shqy>

                            <div @click="logout">
                                <img src="../assets/img/logout.png" style="height: 20px;width: 20px;">
                                &nbsp; 退出登录
                            </div>
                        </div>
                    </div>
                    <div slot="reference" class="user-list">
                        <div class="user-img">
                            <img v-if="userInfo.companyLogo" :src="userInfo.companyLogo" alt="">
                            <img v-else src="../assets/img/qyzx.png" alt="">

                        </div>
                        <div class="user-name">

                            <div>
                                <span v-if="userInfo.currentLoginName">{{ userInfo.currentLoginName }}</span>
                                <span v-else> {{ hidePhoneNumber(userInfo.mobile) }}</span>
                            </div>
                            <div>{{ userInfo.companyName }} <i
                                    class="el-icon-caret-bottom
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    "></i>
                            </div>
                        </div>
                    </div>
                </el-popover>
                <!-- <el-dropdown @command="handleUser">
                        <span class="el-dropdown-link">
                            <span class="username">{{ userInfo.currentLoginName }}</span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="logout">
                                <div class="logout-wrapper">
                                    <img src="../assets/img/logout.png" alt="" class="logout-img">
                                    退出登录
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
            </div>
        </div>


    </div>
</template>

<script>
import shqy from '@/components/shqy';
import { switchCompanyChange, getAllCompany, userCompanyInfo, userLogout, getCompanyDetail, justifyAdmin } from '@/api/index.js';
import config from '../config';
export default {
    name: '',
    components: {
        shqy

    },
    data() {
        return {
            companyLogo: "https://pili-vod.live-stg.taxchina.com/4906c2c7177b4682abf4eff9d302e721.png",
            userInfo: {}, companyData: [], dept: "", token: ''
        }
    },
    created() {
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
        // if (this.$route.params.dept) {
        //     this.dept = this.$route.params.dept;
        // }
        if (window.localStorage.getItem('dept')) {
            this.dept = window.localStorage.getItem('dept');
        }

        // if (this.$route.params.token) {
        //     this.token = this.$route.params.token
        //     localStorage.setItem('token', this.$route.params.token)
        // }
        if (localStorage.getItem('token')) {
            this.token = localStorage.getItem('token');
        }
        // this.getTodept()
        // this.justifyActiveAdmin();
        // this.dept = window.localStorage.getItem('dept');
        // this.token = window.localStorage.getItem('token');
        //  this.getTodept();
        if (window.localStorage.getItem('user')) {
            this.userInfo = JSON.parse(window.localStorage.getItem('user'))
        } else {
            this.companyDetailInfo()
        }
    },
    mounted() {

        scrollTo(0, 0);
        // this.dept = window.localStorage.getItem('dept');
        // this.token = window.localStorage.getItem('token');

    },
    methods: {
        to() {
            console.log(window, 'window')
            //  window.location.href = 'https://hxt.saas.taxchina.com';

            window.open('https://hxt.saas.taxchina.com', '_blank');
        },
        changeCompany(row) {

            var host = window.location.host;
            var port = window.location.port;
            if (port && port != '') {
                port = ':' + port;
            }
            var newDomain = row.domain;
            var hash = '/' + window.location.hash;
            //  var newURL = newDomain + port + '/#/index/enterprise-center/' + row.deptId + '/' + this.token;
            //修改跳转带token
            //  var newURL = newDomain + port + "/#/index?idName=enterprise-center&deptId=" + row.deptId + "&token=" + this.token
            var newURL = `${newDomain}${port}/#/index?idName=enterprise-center&deptId=${row.deptId}&token=${this.token.replace(/^"|"$/g, '')}`
            if (this.isWorkWechat()) {
                window.localStorage.clear();
            }
            console.log(newURL)
            window.location.href = newURL;
        },
        switchCompanyChange(deptId) {
            switchCompanyChange({
                deptId,
                clientType: 3
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        },
        tabQY(row) {
            this.switchCompanyChange(row.deptId)
            this.changeCompany(row);
        },
        // 判断设备企业微信
        isWorkWechat() {
            //获取user-agaent标识头
            var ua = window.navigator.userAgent.toLowerCase();
            //判断ua和微信浏览器的标识头是否匹配
            if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
                return true;
            } else {
                return false;
            }
        },
        getCompanyData() {
            if (!this.isWorkWechat() || this.isWorkWechat() && this.token) {
                getAllCompany({}, {
                    Authorization: this.token,
                    DeptId: this.dept,

                }).then(res => {
                    if (res.code == 200) {
                        this.companyData = res.data;

                    }
                    return;
                }).catch(err => {
                    //   console.log(err);
                });
            }
        },
        hidePhoneNumber(phoneNumber) {
            if (phoneNumber.length === 11) {
                return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(7);
            } else {
                return phoneNumber;
            }
        },
        getTodept() {
            // this.token = this.$route.params.token
            // this.dept = this.$route.params.dept
            //   console.log(this.token, this.$route.params.token)
            if (this.token)
                userCompanyInfo({}, { Authorization: this.token, }).then(res => {

                    if (res.code == 200) {

                        var data = res.data;
                        this.dept = data.deptId
                        localStorage.setItem('TopDeptId', data.topDeptId);
                        localStorage.setItem('dept', data.deptId)
                        //    this.justifyActiveAdmin();
                    } else {
                        this.$message.error(res.msg)
                        // this.logout();
                    }

                })
        },
        justifyActiveAdmin() {
            const openUrl = config.openUrl;
            justifyAdmin({}, {
                Authorization: this.token,
                DeptId: this.dept,
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    if (data) {
                        //   this.companyDetailInfo();
                    } else {
                        window.location.href = openUrl + '/404';
                    }
                } else {
                    window.location.href = openUrl + '/404';
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        },
        handleUser(command) {
            if (command == 'logout') {
                this.logout();
            }
        },
        logout() {
            userLogout({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    window.localStorage.clear();
                    if (this.isWorkWechat()) {
                        window.sessionStorage.setItem('wxLogout', true)
                        this.$router.push({ path: '/', query: { wxLogout: true } });
                    } else {
                        this.$router.push("/");
                    }
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        },
        // 判断设备企业微信
        isWorkWechat() {
            //获取user-agaent标识头
            var ua = window.navigator.userAgent.toLowerCase();
            //判断ua和微信浏览器的标识头是否匹配
            if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
                return true;
            } else {
                return false;
            }
        },
        companyDetailInfo() {
            getCompanyDetail({}, {
                Authorization: this.token,
                DeptId: this.dept,

            }).then(res => {
                if (res.code == 200) {
                    //   console.log(res, "**************************")
                    var data = res.data;
                    this.userInfo = data;
                    this.$store.dispatch('app/setUserInfo', data);
                    window.localStorage.setItem('user', JSON.stringify(data));
                    //  this.getCompanyData()
                } else {
                    this.$message.error(res.msg);
                    window.localStorage.clear();
                    var _this = this;
                    setTimeout(function () {
                        if (_this.isWorkWechat()) {
                            // window.sessionStorage.setItem('wxLogout',true)
                            _this.$router.push({ path: '/', query: { wxLogout: true } });
                        } else {
                            _this.$router.push("/");
                        }
                    }, 2000);
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        }
    }
}
</script>

<style scoped>
.header-container {
    width: 100%;
    height: 100px;
    background: #fff;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
    position: fixed;
    z-index: 80;
    top: 0px;
    left: 0px;
}

.conten {
    flex: 1;
}

.header-wrapper {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;

    align-items: center;
}


.app {
    margin-top: 20px;
}

.user {
    width: 400px;
    display: flex;
    justify-content: space-between;
}



.user-list {
    width: auto;
    display: flex;
}

.user-img {

    border: 1px solid #ccc;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    overflow: hidden;

}

.user-img>img {
    width: 100%;
    height: 100%;
}

.user-name {
    width: auto;
    margin-left: 10px;
    height: 50px;

}

.user-name>div {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: block;
    white-space: nowrap;
    /* 防止内容换行 */
    overflow: hidden;
    text-overflow: ellipsis;
    /* 超出部分变成省略号 */
}

.tc {
    margin-top: 20px;
    width: 300px;
    display: flex;
    justify-content: space-between;
}

.tc>div {
    display: flex;
    cursor: pointer;
}

.tabQY {
    display: block;
    white-space: nowrap;
    /* 防止内容换行 */
    overflow: hidden;
    text-overflow: ellipsis;
    /* 超出部分变成省略号 */
    width: 250px;

    line-height: 30px;

}

.tabQY>div {
    cursor: pointer;
}
</style>


